import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Small "Verified by owner" badge — rendered when an app has a
 * `verified_owner_email` set (i.e., the publisher has claimed and confirmed
 * the listing). Visual is intentionally distinct from the amber Premium badge:
 * blue BadgeCheck icon, neutral pill, hover-tooltip via title attr.
 *
 * Props:
 *   - app: { verified_owner_email?: string }
 *   - size: 'sm' (12px icon, default) | 'md' (16px icon, used on hero)
 *   - showLabel: when true, renders the text "Verified" next to the icon
 */
const VerifiedBadge = ({ app, size = "sm", showLabel = false }) => {
  if (!app || !app.verified_owner_email) return null;
  const iconSize = size === "md" ? 16 : 12;
  return (
    <span
      title="Verified by owner — claimed by the app team"
      data-testid={`verified-badge-${app.slug || "x"}`}
      className={`inline-flex items-center gap-1 text-[#2563EB] ${showLabel ? "text-[10px] font-bold uppercase tracking-wider bg-blue-50 border border-blue-200 px-1.5 py-0.5 rounded-full" : ""}`}
    >
      <BadgeCheck size={iconSize} className="fill-blue-500 text-white" />
      {showLabel && <span>Verified</span>}
    </span>
  );
};

export default VerifiedBadge;
